import firstSlide from '../assets/images/landing-main-slides/01_slide.png';
import secondSlide from '../assets/images/landing-main-slides/02_slide.png';
import thirdSlide from '../assets/images/landing-main-slides/03_slide.png';
import fourthSlide from '../assets/images/landing-main-slides/04_slide.png';

const landingMainSlides = [
  {
    titleKey: 'first_slide',
    imageUrl: firstSlide,
  },
  {
    titleKey: 'second_slide',
    imageUrl: secondSlide,
  },
  {
    titleKey: 'third_slide',
    imageUrl: thirdSlide,
  },
  {
    titleKey: 'fourth_slide',
    imageUrl: fourthSlide,
  },
];

export default landingMainSlides;
